import axios from "axios";
import { USERS_BASE_URL } from "shared/constants/backend";
import {
  GroupAccessTypeMapping,
  User,
  UserComponentRightsOverview,
} from "shared/models";
import { generateAuthorizationHeaders } from "shared/utils";

export async function fetchAllUsersOfAGroup(
  groupId: string,
  token = ""
): Promise<User[]> {
  if (groupId) {
    const headers = generateAuthorizationHeaders(token);

    const response = await axios.get<User[]>(`${USERS_BASE_URL}/${groupId}/`, {
      headers,
    });
    return response.data;
  }
  return [];
}

export async function createDummyUser(
  groupAccessTypeMapping: GroupAccessTypeMapping[],
  username: string,
  token = ""
): Promise<User> {
  const headers = generateAuthorizationHeaders(token);

  const data = {
    group_access_type_mapping: JSON.stringify(groupAccessTypeMapping),
    username,
  };

  const response = await axios.get<User>(
    `${USERS_BASE_URL}/create_dummy_user/`,
    {
      headers,
      params: data,
    }
  );

  return response.data;
}

export async function getRandomUsername(token = ""): Promise<string> {
  const headers = generateAuthorizationHeaders(token);

  try {
    const response = await axios.get<string>(
      `${USERS_BASE_URL}/get_random_username/`,
      {
        headers,
      }
    );

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error fetching random username:", error);
    throw error;
  }
}

export async function deleteUser(userId: string, token = ""): Promise<void> {
  const headers = generateAuthorizationHeaders(token);

  const response = await axios.delete(`${USERS_BASE_URL}/${userId}/`, {
    headers,
  });

  return response.data;
}

export async function editUser(user: User, token = ""): Promise<User> {
  const headers = generateAuthorizationHeaders(token);
  const response = await axios.patch(`${USERS_BASE_URL}/edit/`, user, {
    headers,
  });

  return response.data;
}

export async function toggleUserStatus(
  userId: string,
  isActive: boolean,
  token = ""
): Promise<User> {
  const headers = generateAuthorizationHeaders(token);

  const response = await axios.patch<User>(
    `${USERS_BASE_URL}/toggle-status/`,
    { userId, isActive },
    {
      headers,
    }
  );
  return response.data;
}

export async function getUserComponentRightsOverview(
  token = "",
  targetUserId?: string
): Promise<UserComponentRightsOverview> {
  const headers = generateAuthorizationHeaders(token);
  const response = await axios.get<UserComponentRightsOverview>(
    `${USERS_BASE_URL}/component-rights-overview/`,
    {
      headers,
      params: targetUserId ? { target_user_id: targetUserId } : undefined,
    }
  );
  return response.data;
}
